var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * If the parameter is both set, and is not null
 * @param toCheck
 * @returns {boolean}
 */
import axios from "axios";
import * as moment from 'moment';
import urls from "../../urls";
class Info {
    //This insures that we are getting exactly what we expect (or an exception)
    constructor(info) {
        this.name = info.name;
        this.summary = info.summary;
        this.details = info.details;
        this.about = info.about;
    }
}
class StatusMessage {
    //This insures that we are getting exactly what we expect (or an exception)
    constructor(message) {
        this.created_at = moment(message.created_at);
        message.annunciators = message.annunciators || [];
        this.annunciators = [];
        for (let annunciator of message.annunciators) {
            let newAnnunciator = {};
            newAnnunciator.active = annunciator.active;
            newAnnunciator.title = annunciator.title.trim();
            newAnnunciator.message = annunciator.message.trim();
            this.annunciators.push(newAnnunciator);
        }
    }
    get activeAnnunciators() {
        return this.annunciators.filter(annunciator => annunciator.active);
    }
    get inactiveAnnunciators() {
        return this.annunciators.filter(annunciator => !annunciator.active);
    }
}
export class Edar {
    //This insures that we are getting exactly what we expect (or an exception)
    constructor(edar) {
        //Copying over the details (while converting sub-objects to the appropriate classes)
        this.id = edar.id;
        this.serial_number = edar.serial_number;
        this.description = edar.description;
        this.online = edar.online;
        this.updated_at = edar.updated_at || null;
        this.last_seen = edar.last_seen || null;
        this.fault_detected = edar.fault_detected || null;
        this.last_status_message = edar.last_status_message ? new StatusMessage(edar.last_status_message) : null;
        this.infos = [];
        if (Array.isArray(edar.infos)) {
            for (let info of edar.infos) {
                this.infos.push(new Info(info));
            }
        }
        //Modifications for readability
        this.description = this.description.trim();
        if (this.updated_at) {
            this.updated_at = moment(this.updated_at);
        }
        if (this.last_seen) {
            this.last_seen = moment(this.last_seen);
        }
        //Sanity check
        if (this.fault_detected &&
            (this.last_status_message === null || !this.last_status_message.activeAnnunciators.length)) {
            console.log(`Edar ${this.serial_number} sanity check failed! .`);
            throw TypeError("Sanity check failed.  fault_detected requires at least one active annunciator.");
        }
    }
    get status() {
        return this.online ? this.fault_detected ? 'Faulted' : 'Online' : 'Offline';
    }
    get baseName() {
        return "EDAR " + this.serial_number;
    }
    get name() {
        let name = this.baseName;
        if (!this.online) {
            name += ` (${this.status})`;
        }
        return name;
    }
    // Equivalent to python's __str__ built in function
    toString() {
        return this.name;
    }
}
export default {
    namespaced: true,
    state: {
        edars: [],
        _intervalId: null,
    },
    mutations: {
        setEdars(state, payload) {
            let newEdars = [];
            for (let edar of payload) {
                let newEdar = null;
                try {
                    newEdar = new Edar(edar);
                }
                catch (e) {
                    console.log(e);
                    continue;
                }
                newEdars.push(newEdar);
            }
            state.edars = newEdars;
        },
        clearEdars(state, payload) {
            state.edars = [];
        },
        _setIntervalId(state, payload) {
            state._intervalId = payload;
        },
    },
    actions: {
        getEdars(context) {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    let response = yield axios.get(urls.edar);
                    context.commit('setEdars', response.data);
                    resolve();
                }
                catch (error) {
                    reject(error);
                }
            }));
        },
        //Poll for new Edar status every minute
        //In some ways, this is more costly than websockets,
        // but it's easier and means there isn't an open connection.
        startPolling(context) {
            if (context.state._intervalId) {
                return;
            }
            let intervalId = setInterval(() => {
                context.dispatch('getEdars');
            }, 60000);
            context.commit('_setIntervalId', intervalId);
        },
        stopPolling(context) {
            if (!context.state._intervalId) {
                return;
            }
            clearInterval(context.state._intervalId);
            context.commit('_setIntervalId', null);
        },
    },
    getters: {
        byId: state => id => {
            return state.edars.find(edar => {
                return String(edar.id) === String(id);
            });
        }
    }
};
